module.exports = __webpack_public_path__ + "static/img/cabinet24_2.dda1d86e.gif";